import React, {useEffect} from 'react';
import {navigate} from 'gatsby';
import {useQuery} from '@apollo/react-hooks';
import {PageHero} from '../../components/page-hero';
import Layout from '../../components/layout/layout';
import Section from '../../components/section';
import PricingPackeges from '../../components/pricing/pricingPackeges';
import TrustedSection from '../../components/trusted-section';
import Countdown from '../../components/countdown';
import {GET_HEXOMATIC_USER} from '../../graphql/queries';
import {
  ANNUAL_PROMO_97097_END,
  isAnnualPromo97097Ended,
} from '../../constants/pricingAnnualGoldSpecialPromo';

const Promo97097 = ({pageContext}: any) => {
  const {data: hexomaticUserInfo} = useQuery(GET_HEXOMATIC_USER, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const redirectIfEnded = () => {
      if (isAnnualPromo97097Ended()) navigate('/pricing/');
    };
    redirectIfEnded();
    const timer = setInterval(redirectIfEnded, 30000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const hexomaticUser = hexomaticUserInfo?.HexomaticUser?.getByLegacyId;
    if (!hexomaticUser || hexomaticUser.error_code === 'USER_NOT_FOUND') return;
    const currentPackage = hexomaticUser.pricing_package;
    if (currentPackage && currentPackage !== 'FREE') navigate('/pricing/');
  }, [hexomaticUserInfo]);

  return (
    <Layout pricingPage>
      <PageHero
        title="Hexomatic Pricing Plans"
        subtitleEl={
          <p className="m-0 mb-2">
            Silver <span style={{color: '#a801ff', fontWeight: 500}}>$97/year</span> and Gold{' '}
            <span style={{color: '#a801ff', fontWeight: 500}}>$197/year</span>
          </p>
        }
        noPaddingBottom
        titleSmall
        className="pricing-page"
      >
        <Countdown date={ANNUAL_PROMO_97097_END} title="DEAL ENDS IN..." className="lg" />
      </PageHero>
      <Section className="pricing-section">
        <div className="pricing-section mx-auto mt-4">
          <PricingPackeges interval="annual" products={pageContext.products} annualPromo97097 />
        </div>
      </Section>
      <TrustedSection />
    </Layout>
  );
};

export default Promo97097;
